import { render, staticRenderFns } from "./IOITable.vue?vue&type=template&id=88622832&"
import script from "./IOITable.vue?vue&type=script&lang=js&"
export * from "./IOITable.vue?vue&type=script&lang=js&"
import style0 from "./IOITable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports